/**
 * Route for `igaming-bonus-award-and-wager-through-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingBonusAwardAndWagerThroughTrackingPage } from "../features/igaming-bonus-award-and-wager-through-tracking/IgamingBonusAwardAndWagerThroughTrackingPage";

export const igamingBonusAwardAndWagerThroughTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-bonus-award-and-wager-through-tracking",
	component: IgamingBonusAwardAndWagerThroughTrackingPage,
});

export default igamingBonusAwardAndWagerThroughTrackingRoute;
